<div style="display: flex; align-items: center; gap: 6px; font: inherit; line-height: inherit; overflow: hidden;">
  <span class="show-for-sr">{{ isSelected ? 'Row selected' : 'Row not selected' }}</span>
  <span aria-hidden="true" class="checkbox-box isDisabled" style="flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center;">
    <span aria-hidden="true" class="checkbox-check" [style.visibility]="isSelected ? 'visible' : 'hidden'" style="line-height: 1;">&#x2714;</span>
  </span>
  @if (displayValue) {
    <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font: inherit;">{{ displayValue }}</span>
  }
</div>
